import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { deliveryZoneApi } from '@app/store';
import { IDeliveryZone, DeliveryZoneDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { DeliveryZoneForm } from './DeliveryZoneForm';
import { useToast, useTriptych } from '@app/hooks';
import { DeliveryZoneCard } from './DeliveryZoneCard';
import { DeliveryZoneFormValues, transformToUpdatableFormDeliveryZone } from './delivery-zone-form.helpers';
import { useAppDispatch } from '@app/store/hooks';

export const DeliveryZoneCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const dispatch = useAppDispatch();

  const [create, { isLoading, error: apiErrors }] = deliveryZoneApi.useCreateOneDeliveryZonesMutation();

  const formMethods = useForm<DeliveryZoneFormValues>({
    resolver: classValidatorResolver(DeliveryZoneDTO),
    defaultValues: transformToUpdatableFormDeliveryZone(),
  });

  const onCreate = async (formValues: Partial<IDeliveryZone>) => {
    try {
      const deliveryZone = await create(formValues).unwrap();

      // Rafraîchir explicitement la liste des zones après création
      dispatch(
        deliveryZoneApi.util.invalidateTags([{ type: 'DeliveryZones', id: 'LIST' }])
      );

      triptych.close({ mode: 'UPDATE', data: deliveryZone });

      toast.success('Votre zone de livraison a bien été ajoutée.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre zone de livraison.')
    }
  }

  return (
    <Fragment>
      <DeliveryZoneCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Form formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.Content>

          <Panel.FormContainer>

            <DeliveryZoneForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              title="Valider"
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Panel.Content>

      </Form>

    </Fragment>
  );
});

